export default function BrandIntro() {
  return (
    <section id="brand" className="max-w-3xl mx-auto">
      <div className="text-center mb-10">
        <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-5">
          <i className="ri-heart-line text-2xl"></i>
        </div>
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
          关于「女仆不只是工作」
        </h1>
        <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
          一个专注于女仆文化深度内容创作与传播的文化媒体平台
        </p>
      </div>

      <div className="space-y-6 text-sm md:text-base text-foreground-700 leading-relaxed">
        <p>
          <strong className="text-foreground-900">「女仆不只是工作」</strong>诞生于2024年，由一群热爱女仆文化的编辑、研究者与从业者共同创立。我们的初心很简单——让更多人看到女仆文化背后那些被忽视的深度与温度。
        </p>
        <p>
          在传统认知中，"女仆"往往被简化为一种服务职业，或者二次元文化中的一个符号。但我们相信，女仆文化包含着更丰富的内涵：它是<strong className="text-foreground-900">角色认同</strong>的探索，是<strong className="text-foreground-900">情感连接</strong>的实践，是一种独特的<strong className="text-foreground-900">生活方式</strong>。
        </p>
        <p>
          我们通过深度文章、从业者访谈、文化分析和真实故事，从多个维度解构和重建女仆文化的话语体系。无论你是女仆咖啡厅的常客、二次元文化爱好者，还是对女仆职业充满好奇的普通读者，这里都有值得你驻足的内容。
        </p>
        <blockquote className="border-l-4 border-primary-300 pl-5 py-1 my-6">
          <p className="text-foreground-600 italic">
            "温柔是一种力量，而不是软弱。女仆文化教会我们——每个人都有被温柔对待的权利，也都有温柔对待他人的能力。"
          </p>
          <footer className="text-xs text-foreground-400 mt-2">— 编辑部寄语</footer>
        </blockquote>
      </div>
    </section>
  );
}